const Particles2 = ({ sx }) => {
  const _sx = sx ?? {};
  return (
    <svg
      style={_sx}
      width="322"
      height="354"
      viewBox="0 0 322 354"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <line
          x1="99.9558"
          y1="113.458"
          x2="133.394"
          y2="178.358"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="26.0553"
          y1="348.663"
          x2="106.929"
          y2="329.183"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="106.85"
          y1="329.209"
          x2="215.975"
          y2="282.769"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="132.843"
          y1="176.092"
          x2="197.236"
          y2="179.772"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="215.886"
          y1="282.819"
          x2="273.33"
          y2="242.867"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="273.297"
          y1="243.664"
          x2="194.759"
          y2="178.796"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="194.789"
          y1="180.14"
          x2="250.005"
          y2="92.2296"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="249.929"
          y1="92.5292"
          x2="246.434"
          y2="40.6468"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="246.632"
          y1="40.2139"
          x2="296.229"
          y2="2.79554"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="296.971"
          y1="3.43072"
          x2="248.01"
          y2="94.9286"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="247.504"
          y1="93.1924"
          x2="96.5876"
          y2="114.384"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="99.6654"
          y1="113.212"
          x2="145.774"
          y2="128.146"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="145.98"
          y1="128.276"
          x2="195.573"
          y2="180.06"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="145.456"
          y1="128.149"
          x2="250.265"
          y2="92.0228"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="145.898"
          y1="125.769"
          x2="130.436"
          y2="178.928"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="133.307"
          y1="176.679"
          x2="105.677"
          y2="331.887"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="106.614"
          y1="329.418"
          x2="194.646"
          y2="178.159"
          stroke="white"
          strokeOpacity="0.84"
        />
        <line
          x1="195.704"
          y1="180.316"
          x2="214.802"
          y2="285.27"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="195.145"
          cy="179.408"
          r="4"
          transform="rotate(-3.85412 195.145 179.408)"
          fill="white"
        />
        <circle
          cx="195.145"
          cy="179.408"
          r="4"
          transform="rotate(-3.85412 195.145 179.408)"
          fill="white"
        />
        <circle
          cx="195.145"
          cy="179.408"
          r="4"
          transform="rotate(-3.85412 195.145 179.408)"
          fill="white"
        />
        <circle
          cx="195.145"
          cy="179.408"
          r="4"
          transform="rotate(-3.85412 195.145 179.408)"
          fill="white"
        />
        <circle
          cx="195.145"
          cy="179.408"
          r="4"
          transform="rotate(-3.85412 195.145 179.408)"
          fill="white"
        />
        <circle
          cx="195.145"
          cy="179.408"
          r="3.5"
          transform="rotate(-3.85412 195.145 179.408)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="272.618"
          cy="243.345"
          r="4"
          transform="rotate(-3.85412 272.618 243.345)"
          fill="white"
        />
        <circle
          cx="272.618"
          cy="243.345"
          r="4"
          transform="rotate(-3.85412 272.618 243.345)"
          fill="white"
        />
        <circle
          cx="272.618"
          cy="243.345"
          r="4"
          transform="rotate(-3.85412 272.618 243.345)"
          fill="white"
        />
        <circle
          cx="272.618"
          cy="243.345"
          r="4"
          transform="rotate(-3.85412 272.618 243.345)"
          fill="white"
        />
        <circle
          cx="272.618"
          cy="243.345"
          r="4"
          transform="rotate(-3.85412 272.618 243.345)"
          fill="white"
        />
        <circle
          cx="272.618"
          cy="243.345"
          r="3.5"
          transform="rotate(-3.85412 272.618 243.345)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="214.176"
          cy="283.364"
          r="4"
          transform="rotate(-3.85412 214.176 283.364)"
          fill="white"
        />
        <circle
          cx="214.176"
          cy="283.364"
          r="4"
          transform="rotate(-3.85412 214.176 283.364)"
          fill="white"
        />
        <circle
          cx="214.176"
          cy="283.364"
          r="4"
          transform="rotate(-3.85412 214.176 283.364)"
          fill="white"
        />
        <circle
          cx="214.176"
          cy="283.364"
          r="4"
          transform="rotate(-3.85412 214.176 283.364)"
          fill="white"
        />
        <circle
          cx="214.176"
          cy="283.364"
          r="4"
          transform="rotate(-3.85412 214.176 283.364)"
          fill="white"
        />
        <circle
          cx="214.176"
          cy="283.364"
          r="3.5"
          transform="rotate(-3.85412 214.176 283.364)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="107.046"
          cy="329.669"
          r="4"
          transform="rotate(-3.85412 107.046 329.669)"
          fill="white"
        />
        <circle
          cx="107.046"
          cy="329.669"
          r="4"
          transform="rotate(-3.85412 107.046 329.669)"
          fill="white"
        />
        <circle
          cx="107.046"
          cy="329.669"
          r="4"
          transform="rotate(-3.85412 107.046 329.669)"
          fill="white"
        />
        <circle
          cx="107.046"
          cy="329.669"
          r="4"
          transform="rotate(-3.85412 107.046 329.669)"
          fill="white"
        />
        <circle
          cx="107.046"
          cy="329.669"
          r="4"
          transform="rotate(-3.85412 107.046 329.669)"
          fill="white"
        />
        <circle
          cx="107.046"
          cy="329.669"
          r="3.5"
          transform="rotate(-3.85412 107.046 329.669)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="26.1723"
          cy="349.15"
          r="4"
          transform="rotate(-3.85412 26.1723 349.15)"
          fill="white"
        />
        <circle
          cx="26.1723"
          cy="349.15"
          r="4"
          transform="rotate(-3.85412 26.1723 349.15)"
          fill="white"
        />
        <circle
          cx="26.1723"
          cy="349.15"
          r="4"
          transform="rotate(-3.85412 26.1723 349.15)"
          fill="white"
        />
        <circle
          cx="26.1723"
          cy="349.15"
          r="4"
          transform="rotate(-3.85412 26.1723 349.15)"
          fill="white"
        />
        <circle
          cx="26.1723"
          cy="349.15"
          r="4"
          transform="rotate(-3.85412 26.1723 349.15)"
          fill="white"
        />
        <circle
          cx="26.1723"
          cy="349.15"
          r="3.5"
          transform="rotate(-3.85412 26.1723 349.15)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="132.747"
          cy="175.593"
          r="4"
          transform="rotate(-3.85412 132.747 175.593)"
          fill="white"
        />
        <circle
          cx="132.747"
          cy="175.593"
          r="4"
          transform="rotate(-3.85412 132.747 175.593)"
          fill="white"
        />
        <circle
          cx="132.747"
          cy="175.593"
          r="4"
          transform="rotate(-3.85412 132.747 175.593)"
          fill="white"
        />
        <circle
          cx="132.747"
          cy="175.593"
          r="4"
          transform="rotate(-3.85412 132.747 175.593)"
          fill="white"
        />
        <circle
          cx="132.747"
          cy="175.593"
          r="4"
          transform="rotate(-3.85412 132.747 175.593)"
          fill="white"
        />
        <circle
          cx="132.747"
          cy="175.593"
          r="3.5"
          transform="rotate(-3.85412 132.747 175.593)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="144.487"
          cy="126.694"
          r="4"
          transform="rotate(-3.85412 144.487 126.694)"
          fill="white"
        />
        <circle
          cx="144.487"
          cy="126.694"
          r="4"
          transform="rotate(-3.85412 144.487 126.694)"
          fill="white"
        />
        <circle
          cx="144.487"
          cy="126.694"
          r="4"
          transform="rotate(-3.85412 144.487 126.694)"
          fill="white"
        />
        <circle
          cx="144.487"
          cy="126.694"
          r="4"
          transform="rotate(-3.85412 144.487 126.694)"
          fill="white"
        />
        <circle
          cx="144.487"
          cy="126.694"
          r="4"
          transform="rotate(-3.85412 144.487 126.694)"
          fill="white"
        />
        <circle
          cx="144.487"
          cy="126.694"
          r="3.5"
          transform="rotate(-3.85412 144.487 126.694)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="99.444"
          cy="112.69"
          r="4"
          transform="rotate(-3.85412 99.444 112.69)"
          fill="white"
        />
        <circle
          cx="99.444"
          cy="112.69"
          r="4"
          transform="rotate(-3.85412 99.444 112.69)"
          fill="white"
        />
        <circle
          cx="99.444"
          cy="112.69"
          r="4"
          transform="rotate(-3.85412 99.444 112.69)"
          fill="white"
        />
        <circle
          cx="99.444"
          cy="112.69"
          r="4"
          transform="rotate(-3.85412 99.444 112.69)"
          fill="white"
        />
        <circle
          cx="99.444"
          cy="112.69"
          r="4"
          transform="rotate(-3.85412 99.444 112.69)"
          fill="white"
        />
        <circle
          cx="99.444"
          cy="112.69"
          r="3.5"
          transform="rotate(-3.85412 99.444 112.69)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="248.5"
          cy="93.6276"
          r="4"
          transform="rotate(-3.85412 248.5 93.6276)"
          fill="white"
        />
        <circle
          cx="248.5"
          cy="93.6276"
          r="4"
          transform="rotate(-3.85412 248.5 93.6276)"
          fill="white"
        />
        <circle
          cx="248.5"
          cy="93.6276"
          r="4"
          transform="rotate(-3.85412 248.5 93.6276)"
          fill="white"
        />
        <circle
          cx="248.5"
          cy="93.6276"
          r="4"
          transform="rotate(-3.85412 248.5 93.6276)"
          fill="white"
        />
        <circle
          cx="248.5"
          cy="93.6276"
          r="4"
          transform="rotate(-3.85412 248.5 93.6276)"
          fill="white"
        />
        <circle
          cx="248.5"
          cy="93.6276"
          r="3.5"
          transform="rotate(-3.85412 248.5 93.6276)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="295.599"
          cy="4.25969"
          r="4"
          transform="rotate(-3.85412 295.599 4.25969)"
          fill="white"
        />
        <circle
          cx="295.599"
          cy="4.25969"
          r="4"
          transform="rotate(-3.85412 295.599 4.25969)"
          fill="white"
        />
        <circle
          cx="295.599"
          cy="4.25969"
          r="4"
          transform="rotate(-3.85412 295.599 4.25969)"
          fill="white"
        />
        <circle
          cx="295.599"
          cy="4.25969"
          r="4"
          transform="rotate(-3.85412 295.599 4.25969)"
          fill="white"
        />
        <circle
          cx="295.599"
          cy="4.25969"
          r="4"
          transform="rotate(-3.85412 295.599 4.25969)"
          fill="white"
        />
        <circle
          cx="295.599"
          cy="4.25969"
          r="3.5"
          transform="rotate(-3.85412 295.599 4.25969)"
          stroke="white"
          strokeOpacity="0.84"
        />
        <circle
          cx="244.937"
          cy="40.7475"
          r="4"
          transform="rotate(-3.85412 244.937 40.7475)"
          fill="white"
        />
        <circle
          cx="244.937"
          cy="40.7475"
          r="4"
          transform="rotate(-3.85412 244.937 40.7475)"
          fill="white"
        />
        <circle
          cx="244.937"
          cy="40.7475"
          r="4"
          transform="rotate(-3.85412 244.937 40.7475)"
          fill="white"
        />
        <circle
          cx="244.937"
          cy="40.7475"
          r="4"
          transform="rotate(-3.85412 244.937 40.7475)"
          fill="white"
        />
        <circle
          cx="244.937"
          cy="40.7475"
          r="4"
          transform="rotate(-3.85412 244.937 40.7475)"
          fill="white"
        />
        <circle
          cx="244.937"
          cy="40.7475"
          r="3.5"
          transform="rotate(-3.85412 244.937 40.7475)"
          stroke="white"
          strokeOpacity="0.84"
        />
      </g>
    </svg>
  );
};

export default Particles2;
